import { IHubspotContext } from './api';

const createFields = <T>(formData: T) =>
  Object.entries(formData).reduce(
    (acc: { name: string; value: string }[], [name, value]) =>
      value ? [...acc, { name, value }] : acc,
    []
  );

export const prepareHubspotData = <T>(data: T, context: IHubspotContext) => {
  return {
    fields: createFields(data),
    context,
    legalConsentOptions: {
      consent: {
        consentToProcess: true,
        text: 'I agree to allow Brocoders to store and process my personal data.',
      },
    },
  };
};

export const handleGaEvent = ({ event, formType }: { event: string; formType: string }) => {
  if (typeof window === 'undefined') {
    return;
  }
  // @ts-ignore
  window.dataLayer.push({
    event,
    formType,
  });
};
